// extracted by mini-css-extract-plugin
export default {"box":"SendWebhook_box__W2b47","selectTitle":"SendWebhook_selectTitle__7uAg1","title":"SendWebhook_title__bHn79","inputTitle":"SendWebhook_inputTitle__MPK9S"};